import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'silos'
const verb = 'get'

export default class OspreySilosSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = 'b28431bd-a47c-4ed8-9141-cd41a9878297'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name,ownerName',
            sf: 'name',
            sd: 'asc',
            ps: 0,
            pc: 5
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/silos/silos-search-suggestion.js